import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const InvitationGate = ({ guest_name, opened, setOpened }) => {
  useEffect(() => {
    document.body.style.overflow = opened ? "" : "hidden";
    return () => (document.body.style.overflow = "");
  }, [opened]);

  return (
    <AnimatePresence>
      {!opened && (
        <motion.div
          className="fixed inset-0 backdrop-blur-lg z-50"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.8 }}
        >
          <div className="p-12 md:p-24 flex h-full w-full flex-col justify-between text-white">
            <div>
              <p>Wedding of</p>
              <h1 className="text-6xl md:text-8xl lg:text-9xl font-display my-8">
                Caleb & Alyssa
              </h1>
              <p>2026.04.11</p>
            </div>

            <div>
              <p className="text-md md:text-2xl">Dear Mr/Mrs/Ms,</p>
              <h1 className="text-6xl md:text-8xl font-display mb-8">
                {guest_name}
              </h1>
              <button
                onClick={() => setOpened(true)}
                className="w-full px-8 py-4 bg-white text-charcoal rounded-md"
              >
                Open Invitation
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InvitationGate;
